import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Meetings } from './pages/Meetings';
import { Footer } from './components/Footer';
import { TechtonAttributionDemo } from './components/TechtonAttributionDemo';

export default function App() {
  const [showMeeting, setShowMeeting] = useState(false);

  useEffect(() => {
    document.title = 'Techton Video Meetings - Connect with Our Team';
    document.body.classList.add('js-loaded');
    
    const timer = setTimeout(() => {
      document.body.classList.add('transition-enabled');
    }, 300);
    
    return () => {
      clearTimeout(timer);
      document.body.classList.remove('js-loaded');
      document.body.classList.remove('transition-enabled');
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-white relative">
      <Navbar onLogoClick={() => setShowMeeting(false)} />
      <main id="main" tabIndex={-1} className="relative z-10">
        {showMeeting ? (
          <Meetings showMeeting={showMeeting} setShowMeeting={setShowMeeting} />
        ) : (
          <Routes>
            <Route path="/" element={<Meetings showMeeting={showMeeting} setShowMeeting={setShowMeeting} />} />
            <Route path="/attribution-demo" element={<TechtonAttributionDemo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </main>
    </div>
  );
}